import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function MegaPhoneIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M1.688 11.25A4.317 4.317 0 0 1 6 6.938h3.735c.243-.013 5.073-.335 9.671-4.191a1.313 1.313 0 0 1 2.157 1.004v15a1.299 1.299 0 0 1-.756 1.19 1.304 1.304 0 0 1-1.4-.186c-3.75-3.143-7.649-3.938-9.095-4.133v3.188a1.313 1.313 0 0 1-.585 1.093l-1.03.687a1.314 1.314 0 0 1-1.998-.766L5.56 15.538a4.32 4.32 0 0 1-3.872-4.288Zm18.441 7.643a.186.186 0 0 0 .2.027.186.186 0 0 0 .109-.17v-15a.177.177 0 0 0-.108-.17.18.18 0 0 0-.198.027c-4.125 3.46-8.343 4.236-9.816 4.405v6.47c1.47.174 5.688.95 9.813 4.41Zm-12.341.657a.188.188 0 0 0 .285.109l1.032-.687a.189.189 0 0 0 .084-.156v-3.253H6.732l1.056 3.987ZM6 14.438h3.188V8.063H6a3.188 3.188 0 1 0 0 6.375Z"
        fill="currentColor" />
    </BaseIcon>
  )
}
